
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwer() {



  const cardData =
  {
    keyword: 'Pune to Mahabaleshwar Cabs',
    heading: 'AB Ghule Cabs: Pune to Mahabaleshwar Cabs',
    headingDescription: 'AB Ghule Cabs offers the best Pune to Mahabaleshwar cab service, ensuring that your journey is comfortable, safe, and enjoyable. Whether you are visiting Mahabaleshwar for a weekend getaway, sightseeing, or a honeymoon, we provide well-maintained vehicles and experienced drivers who will ensure a smooth ride. Our affordable and reliable service guarantees a memorable trip from Pune to Mahabaleshwar. Pune is approximately 120 km from Mahabaleshwar.',

    top: 'Top Places to Visit in Mahabaleshwar with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Venna Lake",
          description: "Venna Lake is one of the most popular tourist attractions in Mahabaleshwar, offering a serene environment perfect for boating. Surrounded by lush greenery and picturesque views, the calm waters of the lake make it a perfect spot for relaxation. Visitors can enjoy a peaceful boat ride or simply take a leisurely walk along the lake’s edge. With a variety of food stalls and recreational activities available, Venna Lake is an ideal destination for family outings or a quiet day with friends."
        },
        {
          title: "Pratapgad Fort",
          description: "Situated just outside Mahabaleshwar, Pratapgad Fort holds great historical significance in Maratha history, especially during the reign of Shivaji Maharaj. The fort offers stunning views of the surrounding valleys and hills, making it a popular spot for history enthusiasts and nature lovers. The fort itself is a marvel of Maratha architecture, and its strategic location offers panoramic views of the Sahyadri mountain range. A visit to Pratapgad Fort provides a blend of historical insight and natural beauty, making it a must-see for anyone in the area."
        },
        {
          title: "Elephant’s Head Point",
          description: "Elephant’s Head Point is one of Mahabaleshwar’s most iconic viewpoints, offering breathtaking panoramic views of the surrounding hills and valleys. The viewpoint is named after a unique rock formation that resembles the head of an elephant, providing an excellent photo opportunity for visitors. The spot is ideal for nature lovers, trekkers, and photographers looking to capture the stunning landscapes of Mahabaleshwar. The cool breeze and scenic views make it a perfect place to relax and soak in the natural beauty of the area."
        },
        {
          title: "Mapro Garden",
          description: "Mapro Garden is a delightful stop for fruit lovers and those with a sweet tooth. Known for its strawberry-based products, the garden offers fresh fruit juices, ice creams, and a variety of delicious snacks. Visitors can enjoy a stroll through the lush gardens, which are filled with colorful flowers and plants. The garden also features a shop where you can buy fresh strawberries, jams, syrups, and other local treats. Mapro Garden is a great spot for families and food enthusiasts to enjoy the natural beauty of Mahabaleshwar while savoring fresh fruit delights."
        },
        {
          title: "Wilson Point",
          description: "As the highest point in Mahabaleshwar, Wilson Point offers breathtaking views of the sunrise and sunset, making it a must-visit spot for photography enthusiasts. The viewpoint provides panoramic vistas of the valleys and hills surrounding the area, making it an ideal location for scenic walks. The cool and refreshing atmosphere at Wilson Point makes it a great place to unwind and enjoy the natural beauty of Mahabaleshwar. Visitors can often see the clouds rolling over the hills and capture some of the most beautiful landscapes the region has to offer."
        },
        {
          title: "Lingmala Waterfall",
          description: "Lingmala Waterfall is one of the most popular natural attractions in Mahabaleshwar, offering a serene and peaceful environment for nature lovers. The waterfall is surrounded by lush greenery, and its cascading waters provide a soothing sound. It is an excellent spot for photographers looking to capture the beauty of the falls and the surrounding landscape. The trek to Lingmala Waterfall is relatively easy, making it accessible for visitors of all ages. The scenic beauty of the waterfall and its surrounding forest area makes it a perfect spot for a relaxing day out."
        },
        {
          title: "Arthur’s Seat",
          description: "Arthur’s Seat is a famous viewpoint in Mahabaleshwar known for its stunning views of the surrounding valleys and hills. The spot is named after Arthur, a British officer, and offers a panoramic vista of the surrounding areas. It is ideal for nature walks, photography, and simply soaking in the beauty of the region. Visitors can enjoy the cool breeze while witnessing one of the most mesmerizing landscapes in Mahabaleshwar. The unique terrain, with deep valleys and lush greenery, makes Arthur’s Seat a perfect place for anyone seeking peace and natural beauty."
        },
        {
          title: "Chinaman's Waterfall",
          description: "Chinaman’s Waterfall is a picturesque waterfall located in Mahabaleshwar, known for its natural beauty and serene environment. Surrounded by dense forests and lush greenery, the waterfall offers a soothing atmosphere perfect for nature enthusiasts. The cascading waters and the sound of the falls create a tranquil setting, making it an ideal location for photography, picnics, or simply relaxing in the lap of nature. The hike to Chinaman’s Waterfall is enjoyable, and the journey is as captivating as the destination itself."
        },
        {
          title: "Bhilar Waterfalls",
          description: "Bhilar Waterfalls, located near the village of Bhilar, is a hidden gem in Mahabaleshwar. This serene waterfall is surrounded by lush forests, making it a perfect spot for nature walks and peaceful picnics. The waterfall is less crowded compared to other popular attractions in Mahabaleshwar, offering visitors a quiet and tranquil experience. The beauty of Bhilar Waterfalls, combined with the surrounding greenery, makes it a great place to relax and enjoy the natural surroundings while capturing beautiful photographs."
        },
        {
          title: "Maharashtra Nature Park",
          description: "For those interested in wildlife and nature conservation, the Maharashtra Nature Park is an excellent destination. Located on the outskirts of Mahabaleshwar, the park is home to a variety of flora and fauna, making it an ideal spot for nature walks and educational tours. Visitors can explore the diverse ecosystems within the park, which include dense forests, wetlands, and grasslands. The park offers an opportunity to learn about the region's biodiversity and the importance of conservation efforts. Maharashtra Nature Park is a great place for nature enthusiasts and families looking to connect with wildlife in a peaceful setting."
        }
      ],


  services: [
    {
      "name": "Pune to Mahabaleshwar Cab Booking",
      description: "Book a comfortable and reliable cab from Pune to Mahabaleshwar with AB Ghule Cabs. Whether you're planning a short trip or an extended stay, we offer affordable and hassle-free booking options for your journey."
    },
    {
      "name": "Taxi from Pune to Mahabaleshwar",
      description: "Travel from Pune to Mahabaleshwar with AB Ghule Cabs. Our taxi services are designed for comfort and convenience, ensuring you enjoy a smooth ride to this beautiful hill station."
    },
    {
      "name": "Pune to Mahabaleshwar Car Hire",
      description: "Looking to hire a car for your trip from Pune to Mahabaleshwar? AB Ghule Cabs offers reliable and affordable car hire services, with a wide selection of vehicles to choose from for your journey."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi Service",
      description: "AB Ghule Cabs offers professional and safe taxi services from Pune to Mahabaleshwar. Our experienced drivers ensure a comfortable ride with timely service, no matter the purpose of your visit."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Rental",
      description: "Rent a cab for your Pune to Mahabaleshwar trip with AB Ghule Cabs. Choose from a range of vehicles to fit your needs, whether for a day trip or an extended stay, at competitive rates."
    },
    {
      "name": "Pune to Mahabaleshwar Elphinstone Point Car",
      description: "Planning to visit Elphinstone Point in Mahabaleshwar? Book a car with AB Ghule Cabs for a comfortable and scenic drive to this popular viewpoint. Enjoy breathtaking views on your way."
    },
    {
      "name": "Pune to Mahabaleshwar Pratapgad Fort Car",
      description: "Visit the historic Pratapgad Fort with AB Ghule Cabs. We provide taxi services for a trip to the fort, ensuring a smooth and comfortable journey from Pune to Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Price",
      description: "The price for a cab from Pune to Mahabaleshwar varies based on the type of vehicle, the duration of the trip, and the number of passengers. Contact AB Ghule Cabs for a quote tailored to your needs."
    },
    {
      "name": "Pune to Mahabaleshwar 2 Days Taxi Fare",
      description: "Looking for a 2-day trip to Mahabaleshwar? AB Ghule Cabs offers affordable pricing for multi-day taxi bookings, including hotel pick-up and drop-off. Get in touch for customized fare options."
    },
    {
      "name": "Book Cab from Pune to Mahabaleshwar",
      description: "Booking a cab from Pune to Mahabaleshwar has never been easier. AB Ghule Cabs offers simple and convenient booking options online, ensuring a hassle-free experience."
    },
    {
      "name": "Pune to Mahabaleshwar Cabs",
      description: "AB Ghule Cabs provides reliable taxi services for your Pune to Mahabaleshwar journey. Choose from a wide range of vehicles based on your comfort and budget preferences."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi",
      description: "Looking for a taxi for your trip to Mahabaleshwar? AB Ghule Cabs offers timely and professional taxi services from Pune to Mahabaleshwar, ensuring you have a stress-free journey."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Price",
      description: "The cost of a cab from Pune to Mahabaleshwar depends on several factors, including vehicle type and travel duration. For the best rates, contact AB Ghule Cabs."
    },
    {
      "name": "Pune to Mahabaleshwar Distance by Taxi Fare",
      description: "Traveling from Pune to Mahabaleshwar by taxi is a comfortable and efficient way to reach the hill station. Get a taxi fare estimate from AB Ghule Cabs based on the distance and time of travel."
    },
    {
      "name": "Pune to Mahabaleshwar Cab for 2 Days",
      description: "Planning to stay for 2 days in Mahabaleshwar? AB Ghule Cabs offers specialized taxi packages for multi-day trips, ensuring you have a reliable and comfortable vehicle for your entire stay."
    },
    {
      "name": "Pune to Mahabaleshwar Car Package",
      description: "AB Ghule Cabs offers customized car packages for your Pune to Mahabaleshwar trip. Choose a package that suits your needs, whether it’s for a day trip or a longer stay."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Service",
      description: "Our Pune to Mahabaleshwar cab service is tailored for comfort and reliability. Whether you’re heading to Mahabaleshwar for leisure or business, AB Ghule Cabs provides top-notch services for all types of travelers."
    },
    {
      "name": "Cab for Mahabaleshwar from Pune",
      description: "Book a reliable cab from Pune to Mahabaleshwar with AB Ghule Cabs. We offer affordable and timely services, ensuring you reach Mahabaleshwar with ease."
    },
    {
      "name": "Pune to Mahabaleshwar Car Rental",
      description: "Rent a car for your trip to Mahabaleshwar with AB Ghule Cabs. Our car rental services are perfect for individuals, families, or groups, providing flexibility and comfort throughout your journey."
    },
    {
      "name": "Cab Service from Pune to Mahabaleshwar",
      description: "AB Ghule Cabs offers professional taxi services for the Pune to Mahabaleshwar route. Our drivers are well-trained and experienced, ensuring your journey is smooth and enjoyable."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Charges",
      description: "The charges for a cab from Pune to Mahabaleshwar depend on the vehicle type, trip duration, and other factors. Contact AB Ghule Cabs for an accurate quote for your trip."
    },
    {
      "name": "Taxi Service from Pune to Mahabaleshwar",
      description: "Enjoy a smooth and comfortable ride with AB Ghule Cabs’ taxi service from Pune to Mahabaleshwar. We offer reliable, on-time services for your convenience."
    },
    {
      "name": "Taxi for Mahabaleshwar from Pune",
      description: "Need a taxi for your trip to Mahabaleshwar? AB Ghule Cabs offers timely and affordable taxi services for all your travel needs from Pune to Mahabaleshwar."
    },
    {
      "name": "Pune to Tapola Cab",
      description: "Plan a trip from Pune to Tapola? Book a reliable cab with AB Ghule Cabs for a comfortable and scenic journey to this beautiful destination near Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      description: "Travel with your group in comfort by booking a tempo traveller for your Pune to Mahabaleshwar trip. AB Ghule Cabs offers spacious tempo travellers for group bookings."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi Drop",
      description: "Need a one-way drop from Pune to Mahabaleshwar? AB Ghule Cabs provides reliable and timely taxi drop services, ensuring you reach your destination on time."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Cost",
      description: "The cost of a cab from Pune to Mahabaleshwar depends on several factors, including vehicle type and journey duration. Get in touch with AB Ghule Cabs for accurate pricing."
    },
    {
      "name": "Pune Airport to Mahabaleshwar Cabs",
      description: "If you’re flying into Pune and heading to Mahabaleshwar, AB Ghule Cabs offers comfortable and timely airport transfer services to your destination."
    },
    {
      "name": "Pune to Mahabaleshwar Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Mahabaleshwar Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Mahabaleshwar Cab Booking", "-Taxi from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Car Hire", "-Pune to Mahabaleshwar taxi service"],
    ["Pune to Mahabaleshwar Cab Rental", "-Pune to Mahabaleshwar Elphinstone Point Car"],
    ["Pune to Mahabaleshwar Pratapgad Fort car", "-Pune to Mahabaleshwar Cab Price"],
    ["Pune to Mahabaleshwar 2 days taxi fare", "-Book cab from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Cabs", "-Pune to Mahabaleshwar Taxi"],
    ["Pune to Mahabaleshwar cab price", "-Pune to Mahabaleshwar distance by taxi fare"],
    ["Pune to Mahabaleshwar cab for 2 days", "-Pune to Mahabaleshwar Car Package"],
    ["Pune to Mahabaleshwar cab service", "-Cab for Mahabaleshwar from Pune"],
    ["Pune to Mahabaleshwar car rental", "-Cab service from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar cab charges", "-Taxi service from Pune to Mahabaleshwar"],
    ["Taxi for Mahabaleshwar from Pune", "-Pune to Tapola cab"],
    ["Pune to Mahabaleshwar tempo traveller", "-Pune to Mahabaleshwar taxi drop"],
    ["Pune to Mahabaleshwar cab cost", "-Pune airport to Mahabaleshwar cabs"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Timely Service",
      WhyChoosedescription: "At AB Ghule Cabs, we guarantee reliable and on-time services for your Pune to Mahabaleshwar journey. Our drivers ensure you travel comfortably and reach your destination on time, whether it's a family trip, a vacation, or a corporate outing."
    },
    {
      WhyChooseheading: "Comfortable and Spacious Vehicles",
      WhyChoosedescription: "Our fleet includes a range of well-maintained vehicles, from sedans to SUVs and luxury cars. Enjoy a comfortable ride with ample legroom and a smooth drive through scenic routes between Pune and Mahabaleshwar."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are highly skilled, professional, and familiar with the best routes from Pune to Mahabaleshwar. They prioritize your safety and comfort, ensuring you enjoy a peaceful and stress-free ride."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive prices for your trip from Pune to Mahabaleshwar. Our pricing structure is transparent, and there are no hidden charges. You can expect great value for money on every ride."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it's an early morning trip or a late-night return, we are available 24/7 for your convenience. You can book a cab at any time, and we’ll ensure that your journey is well-organized and prompt."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "All our vehicles undergo regular maintenance to ensure safety, cleanliness, and comfort during your journey. You can trust that you will be traveling in a well-maintained, air-conditioned vehicle for a pleasant ride."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "Our top priority is your safety. With GPS-equipped vehicles and background-checked, experienced drivers, your trip from Pune to Mahabaleshwar will be both safe and comfortable, even on winding hill roads."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a cab with AB Ghule Cabs is simple and convenient. You can book your ride online via our website or app, or just give us a call to arrange your transportation."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Pune to Mahabaleshwar cab with AB Ghule Cabs?',
      answer: 'You can book a cab online via our website or mobile app, or call our customer service to arrange your ride. We offer a fast and hassle-free booking process.',
    },
    {
      id: 'FAQ2',
      question: 'Are the drivers experienced for Pune to Mahabaleshwar trips?',
      answer: 'Yes, our drivers are well-experienced and familiar with the Pune to Mahabaleshwar route. They are trained to drive safely on hilly terrains and ensure a comfortable journey.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking from Pune to Mahabaleshwar?',
      answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars. Choose the one that best suits your preferences, whether you are traveling alone, with family, or in a group.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride from Pune to Mahabaleshwar?',
      answer: 'You can pay using cash, credit/debit cards, or through online payment options available in our app. We provide multiple payment methods for your convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Mahabaleshwar?',
      answer: 'Yes, you can book a round trip for your convenience. Simply provide your return details during the booking process, and we’ll arrange everything for you.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, depending on the nature of the trip. However, we provide transparent pricing, and all extra charges will be communicated to you upfront.',
    },
    {
      id: 'FAQ7',
      question: 'Can I hire a cab for sightseeing in Mahabaleshwar?',
      answer: 'Yes, we offer sightseeing services in Mahabaleshwar. You can hire a cab for a customized tour of local attractions, and our drivers will assist you in exploring the beautiful hill station.',
    },
    {
      id: 'FAQ8',
      question: 'How much luggage can I carry on my trip to Mahabaleshwar?',
      answer: 'Our vehicles allow for standard luggage. If you have extra luggage, please inform us during booking so we can accommodate your needs.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for corporate travel to Mahabaleshwar?',
      answer: 'Yes, we provide corporate travel solutions for employees, business meetings, or events in Mahabaleshwar. Get in touch with us to discuss customized packages for your corporate needs.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs the best choice for Pune to Mahabaleshwar travel?',
      answer: 'AB Ghule Cabs stands out because of our professional drivers, affordable pricing, well-maintained fleet, round-the-clock availability, and excellent customer support. We ensure that your journey from Pune to Mahabaleshwar is comfortable, safe, and enjoyable.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rajeev Sharma',
      feedback: 'I traveled from Pune to Mahabaleshwar with AB Ghule Cabs and it was a wonderful experience. The car was very comfortable, and the driver knew the best routes to avoid traffic. The entire journey was smooth, and we even got to enjoy the scenic views along the way. Highly recommend this service for anyone planning a trip to Mahabaleshwar!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Anjali Mehta',
      feedback: 'AB Ghule Cabs provided excellent service for our family trip to Mahabaleshwar. The driver was punctual, friendly, and very professional. The car was clean, spacious, and well-maintained, making our trip very comfortable. I will definitely use their services again for future trips.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mahabaleshwar Cabs | Reliable & Affordable</title>
  <meta name="description" content="Book Pune to Mahabaleshwar cabs with AB Ghule Cabs. Affordable, reliable, and luxurious options available for one-way, round trips, and sightseeing. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mahabaleshwar Cab Booking, Taxi from Pune to Mahabaleshwar, Pune to Mahabaleshwar Car Hire, Pune to Mahabaleshwar taxi service, Pune to Mahabaleshwar Cab Rental, Pune to Mahabaleshwar Elphinstone Point Car, Pune to Mahabaleshwar Pratapgad Fort car, Pune to Mahabaleshwar Cab Price, Pune to Mahabaleshwar 2 days taxi fare, Book cab from Pune to Mahabaleshwar, Pune to Mahabaleshwar Cabs, Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar cab price, Pune to Mahabaleshwar distance by taxi fare, Pune to Mahabaleshwar cab for 2 days, Pune to Mahabaleshwar Car Package, Pune to Mahabaleshwar cab service, cab for Mahabaleshwar from Pune, Pune to Mahabaleshwar car rental, Cab service from Pune to Mahabaleshwar, Pune to Mahabaleshwar cab charges, taxi service from Pune to Mahabaleshwar, Taxi for Mahabaleshwar from Pune, Pune to Tapola cab, Pune to Mahabaleshwar tempo traveller, Pune to Mahabaleshwar taxi drop, Pune to Mahabaleshwar cab cost, Pune airport to Mahabaleshwar cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mahabaleshwar Cabs | Reliable & Affordable" />
  <meta property="og:description" content="Book Pune to Mahabaleshwar cabs with AB Ghule Cabs. Affordable, reliable, and luxurious options available for one-way, round trips, and sightseeing. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mahabaleshwar-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mahabaleshwar-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mahabaleshwar Cabs",
        description: "Book Pune to Mahabaleshwar cabs with AB Ghule Cabs. Affordable, reliable, and luxurious options available for one-way, round trips, and sightseeing. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mahabaleshwar-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mahabaleshwar-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mahabaleshwar-cabs.jpg",
        "priceRange": "₹2500 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mahabaleshwar-cabs",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1100"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rahul Deshmukh"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Wonderful service! The journey from Pune to Mahabaleshwar was smooth and enjoyable. Highly recommend AB Ghule Cabs."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-20",
            "reviewBody": "Professional drivers and well-maintained cars. The best way to visit Mahabaleshwar from Pune."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mahabaleshwar",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "17.9239",
            "longitude": "73.6568"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mahabaleshwar-cabs"
        },
        "keywords": "Pune to Mahabaleshwar Cab Booking, Taxi from Pune to Mahabaleshwar, Pune to Mahabaleshwar Car Hire, Pune to Mahabaleshwar taxi service, Pune to Mahabaleshwar Cab Rental, Pune to Mahabaleshwar Elphinstone Point Car, Pune to Mahabaleshwar Pratapgad Fort car, Pune to Mahabaleshwar Cab Price, Pune to Mahabaleshwar 2 days taxi fare, Book cab from Pune to Mahabaleshwar, Pune to Mahabaleshwar Cabs, Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar cab price, Pune to Mahabaleshwar distance by taxi fare, Pune to Mahabaleshwar cab for 2 days, Pune to Mahabaleshwar Car Package, Pune to Mahabaleshwar cab service, cab for Mahabaleshwar from Pune, Pune to Mahabaleshwar car rental, Cab service from Pune to Mahabaleshwar, Pune to Mahabaleshwar cab charges, taxi service from Pune to Mahabaleshwar, Taxi for Mahabaleshwar from Pune, Pune to Tapola cab, Pune to Mahabaleshwar tempo traveller, Pune to Mahabaleshwar taxi drop, Pune to Mahabaleshwar cab cost, Pune airport to Mahabaleshwar cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/17.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomahabaleshwer;